import { useCallback, useEffect, useRef } from 'react';

import { LiveChatWidget } from '@livechat/widget-react';

import { isSSR } from '@telialt/utils/src/helpers';
import { useUserDataQueryBase } from '@telialt/utils/src/SSO/useUserData';

const PageActions = () => {
    const { userData } = useUserDataQueryBase({ isEnabled: !isSSR() });
    const liveChatLicenseId = process.env.LIVE_CHAT_LICENSE_ID;
    const isReadyRef = useRef(false);

    const updateSessionVariables = useCallback(() => {
        if (!isReadyRef.current || userData === undefined) {
            return;
        }
        const customerData = window.LiveChatWidget?.get('customer_data');
        const previousSessionVariables = customerData?.sessionVariables;
        const { sessionToken, businessPartnerId } = previousSessionVariables || {};
        const hasSessionTokenChanged = sessionToken !== userData?.sessionToken;
        const hasBusinessPartnerIdChanged = businessPartnerId !== userData?.id;

        const updatedSessionVariables = {
            sessionToken:
                !sessionToken || sessionToken === '1' || hasSessionTokenChanged
                    ? (userData?.sessionToken ?? '1')
                    : sessionToken,
            businessPartnerId:
                !businessPartnerId || businessPartnerId === '1' || hasBusinessPartnerIdChanged
                    ? (userData?.id ?? '1')
                    : businessPartnerId,
        };

        window.LiveChatWidget?.call('update_session_variables', updatedSessionVariables);
    }, [userData]);

    const handleLiveChatReady = () => {
        if (isSSR()) {
            return;
        }
        isReadyRef.current = true;
        updateSessionVariables();
    };

    useEffect(() => {
        updateSessionVariables();
    }, [userData, updateSessionVariables]);

    return <LiveChatWidget license={liveChatLicenseId} onReady={handleLiveChatReady} />;
};

export { PageActions };
